import { IOveriew } from "./interface";
import { throwResponse } from "./../../config/axios/index";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";

export const useGetOverview = (): UseQueryResult<IOveriew, Error> => {
  return useQuery(
    ["overview"],
    async () => {
      const res = await axios.get("/overview");
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    { keepPreviousData: true }
  );
};
